export const LoadMenu = {
  routes: [
    {
      name: 'loads',
      displayName: 'menu.loads',
      subject_class: 'Loads'
    },
    {
      name: 'load_palletizing',
      displayName: 'menu.load_palletizing',
      subject_class: 'LoadPalletizing'
    },
    {
      name: 'load_sequence',
      displayName: 'menu.load_sequence',
      subject_class: 'LoadSequence'
    },
    {
      name: 'deliveries',
      displayName: 'menu.deliveries',
      subject_class: 'Deliveries'
    },
    {
      name: 'quarantine',
      displayName: 'menu.quarantine',
      subject_class: 'Quarantine'
    },
    {
      name: 'loads_finished',
      displayName: 'menu.loads_finished',
      subject_class: 'LoadsFinished'
    },
  ]
}